var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 32,
    viewBox: "0 0 180 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.994229 1.75138C0.30111 1.14266 0.731636 0 1.6541 0H175C177.485 0 179.5 2.01472 179.5 4.5V16V27.5C179.5 29.9853 177.485 32 175 32H1.6541C0.731633 32 0.301109 30.8573 0.994228 30.2486L12.0214 16.7514C12.4749 16.3531 12.4749 15.6469 12.0214 15.2486L0.994229 1.75138Z",
    fill: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishStepIcon);
export default __webpack_public_path__ + "static/media/finish-step-icon.85f2de04ef0a8ccb55464c59222c7d2d.svg";
export { ForwardRef as ReactComponent };